<template>
    <aside class="h-full">
        <transition :duration="300">
            <div class="lg:hidden" v-show="is_menu_open">
                <div class="fixed inset-0 flex z-40">
                    <transition name="overlay-fade" mode="out-in">
                        <div class="fixed inset-0" v-if="is_menu_open" key="overlay" @click="handleCloseMenu">
                            <div class="absolute inset-0 bg-gray-600 opacity-75" aria-hidden="true"></div>
                        </div>
                    </transition>

                    <transition name="menu-translate" mode="out-in">
                        <div class="relative flex flex-col w-28 pt-5 pb-4 bg-custom-600" v-if="is_menu_open" key="menu" >
                            <div class="absolute top-0 right-0 -mr-12 pt-2">
                                <button class="ml-1 flex items-center justify-center h-6 w-6 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" @click="handleCloseMenu">
                                    <span class="sr-only">Close sidebar</span>
                                    <svg-vue icon="times" class="icon -sm -white"></svg-vue>
                                </button>
                            </div>

                            <a href="/" target="_blank" class="flex flex-col items-center flex-shrink-0 px-4 mb-2">
                                <svg-vue icon="logo" class="h-14 w-auto"></svg-vue>
                                <img class="h-14 w-auto" :src="logoUrl" alt="" />
                            </a>

                            <nav class="mt-5 flex-shrink-0 h-full divide-y divide-cyan-800 overflow-y-auto pb-20" aria-label="Sidebar">
                                <div class="px-2 space-y-1">
                                    <router-link v-if="isRoot" :to="{ name: 'corporations' }" class="group flex flex-col items-center mb-4 px-2 py-2 text-sm leading-6 font-medium rounded-md text-center transition-colors" :class="currentRouteName === 'corporations' ? 'text-custom-100 bg-custom-800' : 'text-custom-300 hover:text-custom-100 hover:bg-custom-800'">
                                        <svg-vue icon="briefcase-alt" class="h-6 w-6 fill-current"></svg-vue>Corporations
                                    </router-link>

                                    <router-link v-else-if="authUser.corporation_id" :to="{ name: 'corporation-show', params: {id: authUser.corporation_id} }" class="group flex flex-col items-center mb-4 px-2 py-2 text-sm leading-6 font-medium rounded-md text-center transition-colors" :class="currentRouteName === 'corporations' || currentRouteName === 'corporation-show' ? 'text-custom-100 bg-custom-800' : 'text-custom-300 hover:text-custom-100 hover:bg-custom-800'">
                                        <svg-vue icon="briefcase-alt" class="h-6 w-6 fill-current"></svg-vue>Corporation
                                    </router-link>

                                    <router-link v-if="projects" :to="{ name: 'projects' }" class="group flex flex-col items-center mb-4 px-2 py-2 text-sm leading-6 font-medium rounded-md text-center transition-colors" :class="currentRouteName === 'projects' ? 'text-custom-100 bg-custom-800' : ' text-custom-300 hover:text-custom-100 hover:bg-custom-800'">
                                        <svg-vue icon="building" class="h-6 w-6 fill-current"></svg-vue>Projects
                                    </router-link>

                                    <router-link v-if="domain && domain.id" :to="{ name: 'gallery', params: { domain_id: domain.id } }" class="group flex flex-col items-center mb-4 px-2 py-2 text-sm leading-6 font-medium rounded-md text-center transition-colors" :class="currentRouteName === 'gallery' ? 'text-custom-100 bg-custom-800' : ' text-custom-300 hover:text-custom-100 hover:bg-custom-800'">
                                        <svg-vue icon="images" class="h-6 w-6 fill-current"></svg-vue>Galerie
                                    </router-link>

                                    <router-link v-if="domain && domain.id" :to="{ name: 'videos', params: { domain_id: domain.id } }" class="group flex flex-col items-center mb-4 px-2 py-2 text-sm leading-6 font-medium rounded-md text-center transition-colors" :class="currentRouteName === 'videos' ? 'text-custom-100 bg-custom-800' : ' text-custom-300 hover:text-custom-100 hover:bg-custom-800'">
                                        <svg-vue icon="presentation-play" class="h-6 w-6 fill-current"></svg-vue>Videos
                                    </router-link>

                                    <router-link v-if="domain && domain.id" :to="{ name: 'tours', params: { domain_id: domain.id } }" class="group flex flex-col items-center mb-4 px-2 py-2 text-sm leading-6 font-medium rounded-md text-center transition-colors" :class="currentRouteName === 'tours' ? 'text-custom-100 bg-custom-800' : ' text-custom-300 hover:text-custom-100 hover:bg-custom-800'">
                                        <svg-vue icon="cube" class="h-6 w-6 fill-current"></svg-vue>Tours
                                    </router-link>

                                    <router-link v-if="project && project.id" :to="{ name: 'categories', params: { project_id: project.id } }" class="group flex flex-col items-center mb-4 px-2 py-2 text-sm leading-6 font-medium rounded-md text-center transition-colors" :class="currentRouteName === 'categories' ? 'text-custom-100 bg-custom-800' : ' text-custom-300 hover:text-custom-100 hover:bg-custom-800'">
                                        <svg-vue icon="folder" class="h-6 w-6 fill-current"></svg-vue>Categories
                                    </router-link>

                                    <router-link v-if="project && project.id" :to="{ name: 'statuses', params: { project_id: project.id } }" class="group flex flex-col items-center mb-4 px-2 py-2 text-sm leading-6 font-medium rounded-md text-center transition-colors" :class="currentRouteName === 'statuses' ? 'text-custom-100 bg-custom-800' : ' text-custom-300 hover:text-custom-100 hover:bg-custom-800'">
                                        <svg-vue icon="transaction" class="h-6 w-6 fill-current"></svg-vue>Status
                                    </router-link>
                                </div>
                                <div class="mt-6 pt-6">
                                    <div class="px-2 space-y-1">
                                        <router-link :to="{ name: 'users' }" class="group flex flex-col items-center mb-4 px-2 py-2 text-sm leading-6 font-medium rounded-md text-center transition-colors" :class="currentRouteName === 'users' ? 'text-custom-100 bg-custom-800' : 'text-custom-300 hover:text-custom-100 hover:bg-custom-800'">
                                            <svg-vue icon="users" class="h-6 w-6 fill-current"></svg-vue>Users
                                        </router-link>
                                    </div>
                                </div>
                            </nav>
                        </div>

                    </transition>
                    <div class="flex-shrink-0 w-14" aria-hidden="true">
                        <!-- Dummy element to force sidebar to shrink to fit close icon -->
                    </div>
                </div>
            </div>
        </transition>

        <div class="hidden lg:flex lg:flex-shrink-0 h-full">
            <div class="flex flex-col w-28">
                <div class="flex flex-col flex-grow bg-custom-600 pt-5 pb-4 overflow-y-auto">
                    <a href="/" target="_blank" class="flex flex-col items-center flex-shrink-0 px-4 mb-2">
                        <img class="h-14 w-auto" :src="logoUrl" alt="" />
                    </a>
                    <nav class="mt-5 flex-1 flex flex-col divide-y divide-cyan-800 overflow-y-auto" aria-label="Sidebar">
                        <div class="px-2 space-y-1">
                            <router-link v-if="isRoot" :to="{ name: 'corporations' }" class="group flex flex-col items-center mb-4 px-2 py-2 text-sm leading-6 font-medium rounded-md text-center transition-colors" :class="currentRouteName === 'corporations' ? 'text-custom-100 bg-custom-800' : 'text-custom-300 hover:text-custom-100 hover:bg-custom-800'">
                                <svg-vue icon="briefcase-alt" class="h-6 w-6 fill-current"></svg-vue>Corporations
                            </router-link>

                            <router-link v-else-if="authUser.corporation_id" :to="{ name: 'corporation-show', params: {id: authUser.corporation_id} }" class="group flex flex-col items-center mb-4 px-2 py-2 text-sm leading-6 font-medium rounded-md text-center transition-colors" :class="currentRouteName === 'corporations' || currentRouteName === 'corporation-show' ? 'text-custom-100 bg-custom-800' : 'text-custom-300 hover:text-custom-100 hover:bg-custom-800'">
                                <svg-vue icon="briefcase-alt" class="h-6 w-6 fill-current"></svg-vue>Corporation
                            </router-link>

                            <router-link v-if="projects" :to="{ name: 'projects' }" class="group flex flex-col items-center mb-4 px-2 py-2 text-sm leading-6 font-medium rounded-md text-center transition-colors" :class="currentRouteName === 'projects' ? 'text-custom-100 bg-custom-800' : ' text-custom-300 hover:text-custom-100 hover:bg-custom-800'">
                                <svg-vue icon="building" class="h-6 w-6 fill-current"></svg-vue>Projects
                            </router-link>

                            <router-link v-if="domain && domain.id" :to="{ name: 'gallery', params: { domain_id: domain.id } }" class="group flex flex-col items-center mb-4 px-2 py-2 text-sm leading-6 font-medium rounded-md text-center transition-colors" :class="currentRouteName === 'gallery' ? 'text-custom-100 bg-custom-800' : ' text-custom-300 hover:text-custom-100 hover:bg-custom-800'">
                                <svg-vue icon="images" class="h-6 w-6 fill-current"></svg-vue>Galerie
                            </router-link>

                            <router-link v-if="domain && domain.id" :to="{ name: 'videos', params: { domain_id: domain.id } }" class="group flex flex-col items-center mb-4 px-2 py-2 text-sm leading-6 font-medium rounded-md text-center transition-colors" :class="currentRouteName === 'videos' ? 'text-custom-100 bg-custom-800' : ' text-custom-300 hover:text-custom-100 hover:bg-custom-800'">
                                <svg-vue icon="presentation-play" class="h-6 w-6 fill-current"></svg-vue>Videos
                            </router-link>

                            <router-link v-if="domain && domain.id" :to="{ name: 'tours', params: { domain_id: domain.id } }" class="group flex flex-col items-center mb-4 px-2 py-2 text-sm leading-6 font-medium rounded-md text-center transition-colors" :class="currentRouteName === 'tours' ? 'text-custom-100 bg-custom-800' : ' text-custom-300 hover:text-custom-100 hover:bg-custom-800'">
                                <svg-vue icon="cube" class="h-6 w-6 fill-current"></svg-vue>Tours
                            </router-link>

                            <router-link v-if="project && project.id" :to="{ name: 'categories', params: { project_id: project.id } }" class="group flex flex-col items-center mb-4 px-2 py-2 text-sm leading-6 font-medium rounded-md text-center transition-colors" :class="currentRouteName === 'categories' ? 'text-custom-100 bg-custom-800' : ' text-custom-300 hover:text-custom-100 hover:bg-custom-800'">
                                <svg-vue icon="folder" class="h-6 w-6 fill-current"></svg-vue>Categories
                            </router-link>

                            <router-link v-if="project && project.id" :to="{ name: 'statuses', params: { project_id: project.id } }" class="group flex flex-col items-center mb-4 px-2 py-2 text-sm leading-6 font-medium rounded-md text-center transition-colors" :class="currentRouteName === 'statuses' ? 'text-custom-100 bg-custom-800' : ' text-custom-300 hover:text-custom-100 hover:bg-custom-800'">
                                <svg-vue icon="transaction" class="h-6 w-6 fill-current"></svg-vue>Status
                            </router-link>
                        </div>
                        <div class="mt-6 pt-6">
                            <div class="px-2 space-y-1">
                                <router-link :to="{ name: 'users' }" class="group flex flex-col items-center mb-4 px-2 py-2 text-sm leading-6 font-medium rounded-md text-center transition-colors" :class="currentRouteName === 'users' ? 'text-custom-100 bg-custom-800' : 'text-custom-300 hover:text-custom-100 hover:bg-custom-800'">
                                    <svg-vue icon="users" class="h-6 w-6 fill-current"></svg-vue>Users
                                </router-link>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    </aside>
</template>

<script>
import {directive} from "vue3-click-away";
import USER_ROLE from '../../enums/user-role';

export default {
    props: {
        is_menu_open: Boolean,
    },
    computed: {
        currentRouteName() {
            return this.$route.name;
        },
        currentRouteParams() {
            return this.$route.params;
        },
        locale() {
            return this.$store.state.config.locale;
        },
        authUser() {
            return this.$store.state.auth.auth_user;
        },
        isRoot() {
            return this.$store.getters['auth/isRoot'];
        },
        isUser() {
            if(this.authUser) {
                return Number(this.authUser.role) === Number(USER_ROLE.values.USER.description)
            }

            return false
        },
        corporation() {
            return this.authUser && this.authUser.corporation ? this.authUser.corporation : null;
        },
        settings() {
            return this.corporation && this.corporation.settings ? this.corporation.settings.data : [];
        },
        logoUrl() {
            return this.settings.find( setting => setting.name === 'logo' ) && this.settings.find( setting => setting.name === 'logo' ).image ? this.settings.find( setting => setting.name === 'logo' ).image.url : null
        },
        domain() {
            return this.$store.state.domains.single;
        },
        project() {
            return this.$store.state.projects.single;
        },
        projects() {
            return this.domain && this.domain.projects ? this.domain.projects.data : [];
        },
    },
    methods: {
        handleCloseMenu() {
            this.$emit('close');
        }
    },
    directives: {
        ClickAway: directive
    },
}
</script>
